<template>
  <b-modal size="xl" id="contrato-pdf-aws-app-site" hide-footer> 

    <div class="row">
      <div class="col-12">
        <iframe :src="contratoDados" width="100%" height="700px"></iframe>  
      </div>  
    </div>     
  </b-modal>
</template>

<script>
export default{

  props: {
    contratoDados: {
      required: false,
      default: ''
    },
  }
}
</script>
